import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Tag,
  Tooltip,
  Tabs,
  Drawer,
  Descriptions,
  Typography,
} from "antd";
import "react-phone-input-2/lib/style.css";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import ConfirmationBox from "../../components/ConfirmationBox";
import { ShowToast, Severty } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import { useNavigate } from "react-router";
import apiPath from "../../constants/apiPath";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import EditIcon from "../../assets/images/edit.svg";
import moment from "moment";
import { TabPane } from "react-bootstrap";
import { EditOutlined, EyeOutlined, SearchOutlined } from "@ant-design/icons";
const Search = Input.Search;
const { Title } = Typography;

function ContentManagerTabs() {
  return (
    <Tabs
      className="main-new-tabs-class-098"
      defaultActiveKey="content"
      destroyInactiveTabPane
    >
      <TabPane tab="All Content" key="content">
        <Content />
      </TabPane>
      {/* <TabPane tab="FAQs" key="faq">
        <FAQTab />
      </TabPane> */}
    </Tabs>
  );
}

function Content() {
  const { request } = useRequest();
  const [searchText, setSearchText] = useState(""); // Display text in input
  const [searchQuery, setSearchQuery] = useState(""); // Formatted query for API
  const [pagination, setPagination] = useState({ 
    current: 1, 
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    pageSizeOptions: ['10', '20', '50', '100'],
  });
  const [list, setList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [viewingContent, setViewingContent] = useState(null);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [selected, setSelected] = useState();
  const { showConfirm } = ConfirmationBox();
  const navigate = useNavigate();
  const { confirm } = Modal;

  const viewContent = (id) => {
    request({
      url: `${apiPath.getContentById}?content_id=${id}`,
      method: 'GET',
      onSuccess: (response) => {
        if (response.status) {
          setViewingContent(response.data);
          setViewModalVisible(true);
        }
      },
      onError: () => {
        ShowToast('Failed to fetch content details', Severty.ERROR);
      }
    });
  };

  const columns = [
    {
      title: "Page Type",
      dataIndex: "page_type",
      key: "page_type",
      render: (page_type) => {
        return page_type ? page_type.replace(/_/g, ' ').toUpperCase() : "-";
      },
    },
    {
      title: "Created At",
      key: "created_at",
      dataIndex: "created_at",
      render: (created_at) => {
        return new Date(created_at).toLocaleDateString();
      },
    },
    {
      title: "Updated At",
      key: "updated_at",
      dataIndex: "updated_at",
      render: (updated_at) => {
        return new Date(updated_at).toLocaleDateString();
      },
    },
    {
      title: "Action",
      render: (_, record) => {
        return (
          <div className="d-flex gap-2">
            <Button
              onClick={() => viewContent(record.id)}
            >
              <EyeOutlined />
            </Button>
            <Button
              onClick={() => {
                setSelected(record);
                setVisible(true);
              }}
            >
              <EditOutlined />
            </Button>
          </div>
        );
      },
    },
  ];

  const onSearch = (e) => {
    const value = e.target.value;
    setSearchText(value); // Display as typed
    
    // Format for search: lowercase and replace spaces with underscores
    const formattedValue = value.toLowerCase().replace(/ /g, '_');
    setSearchQuery(formattedValue);
    setPagination(prev => ({ ...prev, current: 1 }));
  };

  const handleClearSearch = () => {
    setSearchText("");
    setSearchQuery("");
    setPagination(prev => ({ ...prev, current: 1 }));
  };

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [refresh, debouncedSearchQuery]);

  const fetchData = (paginationInfo) => {
    const currentPage = paginationInfo?.current || 1;
    const pageSize = paginationInfo?.pageSize || 10;
    
    const params = new URLSearchParams({
      page: currentPage,
      page_size: pageSize,
    });

    // Add search parameter if search query exists
    if (debouncedSearchQuery) {
      params.append('search', debouncedSearchQuery);
    }

    request({
      url: `${apiPath.getAllContent}?${params}`,
      method: "GET",
      onSuccess: (response) => {
        setLoading(false);
        if (response.status) {
          setList(response.data || []);
          setPagination((prev) => ({
            ...prev,
            current: response.pagination?.current_page || currentPage,
            pageSize: response.pagination?.page_size || pageSize,
            total: response.pagination?.total_count || 0,
          }));
        }
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleTableChange = (paginationInfo, filters, sorter) => {
    fetchData(paginationInfo);
  };

  return (
    <>
      <div className="tabled">
        <Row>
          <Col span={24} md={24} lg={24} xl={24}>
            <Card
              bordered={false}
              className="criclebox new-no-radiouss tablespace mb-24"
              title="Content Manager"
              extra={
                <>
                  <div className="w-100 d-flex align-items-baseline text-head_right_cont">
                    <div className="pageHeadingSearch d-flex gap-2">
                      <Input
                        prefix={<SearchOutlined />}
                        onChange={onSearch}
                        value={searchText}
                        allowClear
                        placeholder="Search by Page Type"
                        onClear={handleClearSearch}
                      />
                    </div>
                  </div>
                </>
              }
            >
              <div className="table-responsive customPagination">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={pagination}
                  onChange={handleTableChange}
                  className="ant-border-space"
                  rowKey="id"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      {visible && (
        <AddFrom
          show={visible}
          hide={() => {
            setSelected();
            setVisible(false);
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
      
      {/* View Content Modal */}
      <Modal
        visible={viewModalVisible}
        onCancel={() => setViewModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setViewModalVisible(false)}>
            Close
          </Button>
        ]}
        className="tab_modal"
        width={800}
      >
             <Title level={3}>Content Details</Title>
        {viewingContent && (
          <div>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <strong>Page Type:</strong> {viewingContent.page_type?.replace(/_/g, ' ').toUpperCase()}
              </Col>
              <Col span={24}>
                <strong>Content:</strong>
                <div 
                  style={{ 
                    border: '1px solid #d9d9d9', 
                    padding: '10px', 
                    marginTop: '8px',
                    maxHeight: '400px',
                    overflow: 'auto',
                    whiteSpace: 'pre-wrap'
                  }}
                >
                  {viewingContent.content}
                </div>
              </Col>
              <Col span={12}>
                <strong>Created At:</strong> {new Date(viewingContent.created_at).toLocaleString()}
              </Col>
              <Col span={12}>
                <strong>Updated At:</strong> {new Date(viewingContent.updated_at).toLocaleString()}
              </Col>
            </Row>
          </div>
        )}
      </Modal>
    </>
  );
}

function FAQTab() {
  const { request } = useRequest();
  const [faqList, setFaqList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [searchText, setSearchText] = useState("");
  const debouncedSearchText = useDebounce(searchText, 300);
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState(null);
  const [viewDrawerVisible, setViewDrawerVisible] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const { showConfirm } = ConfirmationBox();
  
  // Pagination state for FAQ
  const [faqPagination, setFaqPagination] = useState({ 
    current: 1, 
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    pageSizeOptions: ['10', '20', '50', '100'],
  });

  useEffect(() => {
    fetchFAQs(faqPagination);
  }, [debouncedSearchText, refresh]);

  const fetchFAQs = (paginationInfo) => {
    const currentPage = paginationInfo?.current || 1;
    const pageSize = paginationInfo?.pageSize || 10;
    
    setLoading(true);
    
    const params = new URLSearchParams({
      page: currentPage,
      page_size: pageSize,
    });

    if (debouncedSearchText) {
      params.append('search', debouncedSearchText);
    }

    request({
      url: `/admin/faq/list?${params}`,
      method: "GET",
      onSuccess: (response) => {
        if (response.status) {
          setFaqList(response.data?.list || []);
          setFaqPagination((prev) => ({
            ...prev,
            current: response.pagination?.current_page || currentPage,
            pageSize: response.pagination?.page_size || pageSize,
            total: response.pagination?.total_count || 0,
          }));
        }
        setLoading(false);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const handleFaqTableChange = (paginationInfo, filters, sorter) => {
    fetchFAQs(paginationInfo);
  };

  const columns = [
    {
      title: "Question",
      dataIndex: "question",
      key: "question",
    },
    {
      title: "Answer",
      dataIndex: "answer",
      key: "answer",
      render: (text) =>
        text?.length > 100 ? text.slice(0, 100) + "..." : text,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div className="d-flex gap-2">
          <Tooltip title="View" color="purple">
            <Button
              className="table-action-btn"
              onClick={() => {
                setSelected(record);
                setDrawerVisible(true);
              }}
            >
              <i className="fas fa-eye" />
            </Button>
          </Tooltip>
          <Tooltip title="Edit" color="purple">
            <Button
              className="table-action-btn"
              onClick={() => {
                setSelected(record);
                setVisible(true);
              }}
            >
              <i className="fas fa-edit" />
            </Button>
          </Tooltip>
        </div>
      ),
    },
  ];

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setFaqPagination(prev => ({ ...prev, current: 1 }));
  };

  return (
    <>
      <Card
        className="new-no-radiouss"
        title="FAQ Management"
        extra={
          <div className="pageHeadingSearch d-flex gap-2">
            <Input.Search
              className="searchInput"
              placeholder="Search By Question"
              allowClear
              onChange={(e) => {
                const trimmedValue = e.target.value.trimStart();
                onSearch({ target: { value: trimmedValue } });
              }}
            />
            <Button
              type="primary"
              className="primary_btn"
              onClick={() => {
                setSelected(null);
                setVisible(true);
              }}
            >
              Add FAQ
            </Button>
          </div>
        }
      >
        <div className="table-responsive">
          <Table
            columns={columns}
            dataSource={faqList}
            loading={loading}
            pagination={faqPagination}
            onChange={handleFaqTableChange}
            rowKey="_id"
          />
        </div>
      </Card>

      {visible && (
        <FAQFormModal
          show={visible}
          hide={() => {
            setSelected(null);
            setVisible(false);
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
      <Drawer
        open={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        title="FAQ Detail"
        placement="right"
        width={500}
        className="faq-drawer"
      >
        {selected && (
          <div className="d-flex flex-column gap-3">
            <div>
              <h5 style={{ fontWeight: 600, marginBottom: 8 }}>Q:</h5>
              <p style={{ fontSize: 16 }}>{selected.question}</p>
            </div>
            <div>
              <h5 style={{ fontWeight: 600, marginBottom: 8 }}>A:</h5>
              <div
                style={{ fontSize: 15, color: "#555" }}
                dangerouslySetInnerHTML={{ __html: selected.answer }}
              />
            </div>
          </div>
        )}
      </Drawer>
    </>
  );
}

const FAQFormModal = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({
      question: data.question,
      answer: data.answer,
    });
  }, [data]);

  const onFinish = (values) => {
    const payload = data ? { ...data, ...values } : values;
    setLoading(true);
    request({
      url: data?._id ? `${apiPath.faqAddEdit}/${data._id}` : apiPath.faqAddEdit,
      method: "POST",
      data: {
        question: payload.question,
        answer: payload.answer,
      },
      onSuccess: (res) => {
        ShowToast(res.message, Severty.SUCCESS);
        refresh();
        hide();
        setLoading(false);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      open={show}
      onCancel={hide}
      onOk={() => form.submit()}
      okText={data ? "Update FAQ" : "Add FAQ"}
      confirmLoading={loading}
      className="tab_modal"
      centered
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <h4 className="modal_title_cls">
          {data?._id ? "Edit FAQ" : "Add FAQs"}
        </h4>
        <Form.Item
          label="Question"
          name="question"
          normalize={(value) => value.trimStart()}
          rules={[{ required: true, message: "Please enter a question" }]}
        >
          <Input placeholder="Enter FAQ question" />
        </Form.Item>
        <Form.Item
          label="Answer"
          name="answer"
          normalize={(value) => value.trimStart()}
          rules={[{ required: true, message: "Please enter an answer" }]}
        >
          <Input.TextArea rows={4} placeholder="Enter FAQ answer" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

const AddFrom = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState("");
  
  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({ 
      page_type: data.page_type,
      description: data.content
    });
    setContent(data.content);
  }, [data]);
  
  const onCreate = (values) => {
    const { description, name } = values;
    const payload = {};
    setLoading(true);
    payload.description = description;
    payload.name = name;
    request({
      url: apiPath.updateContent,
      method: 'PUT',
      data: {
        content_id: data.id,
        content: description,
      },
      onSuccess: (response) => {
        setLoading(false);
        if (response.status) {
          ShowToast(response.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(response.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast('Failed to update content', Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const handleContentChange = (newContent) => {
    setContent(newContent);
    form.setFieldsValue({ description: newContent });
  };
  
  return (
    <Modal
      width={600}
      visible={show}
      okText="Ok"
      onCancel={hide}
      className="tab_modal"
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <h4 class="modal_title_cls">{`${data ? "Edit Content" : "Create"}`}</h4>
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Row>
          <Col span={24}>
            <Form.Item
              label="Page Type"
              name="page_type"
            >
              <Input disabled />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="Description"
              name="description"
              rules={[
                { required: true, message: "Please Enter the  description!" },
              ]}
            >
              <ReactQuill value={content} onChange={handleContentChange} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ContentManagerTabs;